import {
  BaseballEventStatusId,
  BaseballResultId,
} from '@collector/sportsapi-client-legacy'

import {
  createResultIdToAcronymMap,
  ResultWithSliderConfig,
} from '../../configuration'

const resultIdToAcronymMap = createResultIdToAcronymMap(
  [
    BaseballResultId.FirstInning,
    BaseballResultId.SecondInning,
    BaseballResultId.ThirdInning,
    BaseballResultId.FourthInning,
    BaseballResultId.FifthInning,
    BaseballResultId.SixthInning,
    BaseballResultId.SeventhInning,
    BaseballResultId.EighthInning,
    BaseballResultId.NinthInning,
    BaseballResultId.TenthInning,
    BaseballResultId.EleventhInning,
    BaseballResultId.TwelfthInning,
    BaseballResultId.ThirteenthInning,
    BaseballResultId.FourteenthInning,
    BaseballResultId.FifteenthInning,
    BaseballResultId.SixteenthInning,
    BaseballResultId.SeventeenthInning,
    BaseballResultId.EighteenthInning,
    BaseballResultId.NineteenthInning,
    BaseballResultId.TwentiethInning,
    BaseballResultId.TwentyFirstInning,
    BaseballResultId.TwentySecondInning,
    BaseballResultId.TwentyThirdInning,
  ],
  'In',
)

export const eventStatusToResultIdMap = new Map<
  BaseballEventStatusId,
  BaseballResultId
>([
  [BaseballEventStatusId.FirstInning, BaseballResultId.FirstInning],
  [BaseballEventStatusId.SecondInning, BaseballResultId.SecondInning],
  [BaseballEventStatusId.ThirdInning, BaseballResultId.ThirdInning],
  [BaseballEventStatusId.FourthInning, BaseballResultId.FourthInning],
  [BaseballEventStatusId.FifthInning, BaseballResultId.FifthInning],
  [BaseballEventStatusId.SixthInning, BaseballResultId.SixthInning],
  [BaseballEventStatusId.SeventhInning, BaseballResultId.SeventhInning],
  [BaseballEventStatusId.EighthInning, BaseballResultId.EighthInning],
  [BaseballEventStatusId.NinthInning, BaseballResultId.NinthInning],
  [BaseballEventStatusId.TenthInning, BaseballResultId.TenthInning],
  [BaseballEventStatusId.EleventhInning, BaseballResultId.EleventhInning],
  [BaseballEventStatusId.TwelfthInning, BaseballResultId.TwelfthInning],
  [BaseballEventStatusId.ThirteenthInning, BaseballResultId.ThirteenthInning],
  [BaseballEventStatusId.FourteenthInning, BaseballResultId.FourteenthInning],
  [BaseballEventStatusId.FifteenthInning, BaseballResultId.FifteenthInning],
  [BaseballEventStatusId.SixteenthInning, BaseballResultId.SixteenthInning],
  [BaseballEventStatusId.SeventeenthInning, BaseballResultId.SeventeenthInning],
  [BaseballEventStatusId.EighteenthInning, BaseballResultId.EighteenthInning],
  [BaseballEventStatusId.NineteenthInning, BaseballResultId.NineteenthInning],
  [BaseballEventStatusId.TwentiethInning, BaseballResultId.TwentiethInning],
  [BaseballEventStatusId.TwentyFirstInning, BaseballResultId.TwentyFirstInning],
  [
    BaseballEventStatusId.TwentySecondInning,
    BaseballResultId.TwentySecondInning,
  ],
  [BaseballEventStatusId.TwentyThirdInning, BaseballResultId.TwentyThirdInning],
])

export const resultWithSliderConfig: ResultWithSliderConfig<
  BaseballResultId,
  BaseballEventStatusId
> = {
  resultIdToAcronymMap,
  eventStatusToResultIdMap,
  showCurrentResult: true,
}
